import React from 'react'
import PropTypes from 'prop-types'

const BannerDashboard = ({ bannerClasses, bannerId, backgroundStyles, withBackground, children }) => {
    console.log("answer",{ bannerClasses, bannerId, backgroundStyles, withBackground, children })
    return (
        <section id={bannerId} className={`bannerDashboard ${bannerClasses}`}>
            {withBackground ? (
                <div className="banner-bg" style={backgroundStyles}>
                    {(children != null) && children}
                </div>
            ) : (
                <>
                    {(children != null) && children}
                </>
            )}
        </section>
    )
}
BannerDashboard.propTypes = {
    bannerClasses: PropTypes.string,
    bannerId: PropTypes.string,
    backgroundStyles: PropTypes.object,
    children: PropTypes.node
}
BannerDashboard.defaultProps = {
    bannerId: "",
    bannerClasses: "",
    withBackground: true,
    backgroundStyles: {},
}
export default BannerDashboard
